import React, { Component } from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button, Icon, Grid, Label, Segment } from "semantic-ui-react";
import moment from "moment";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import UiMeet3dLink from "~/models/UiMeet3d/UiMeet3dLink";
import UiMeet3dLinkRole from "~/constants/UiMeet3d/UiMeet3dLinkRole";
import UiMeet3dLinkCard from "~/modules/UiMeet3d/components/UiMeet3dLinkCard";
import "../styles/UiMeet3dLinkPairSegment.less";

@observer
class UiMeet3dLinkPairSegment extends Component {
  @computed
  get uiMeet3dLinksOrdered() {
    const { uiMeet3dLinks } = this.props;

    const uiMeet3dLinksOrdered = [];

    uiMeet3dLinks.forEach(uiMeet3dLink => {
      if (uiMeet3dLink.role === UiMeet3dLinkRole.AGENT) {
        uiMeet3dLinksOrdered.unshift(uiMeet3dLink);
      } else {
        uiMeet3dLinksOrdered.push(uiMeet3dLink);
      }
    });

    return uiMeet3dLinksOrdered;
  }

  @computed
  get organizerUiMeet3dLink() {
    if (this.uiMeet3dLinksOrdered.length === 0) {
      return null;
    }

    return this.uiMeet3dLinksOrdered[0];
  }

  @computed
  get endDts() {
    if (this.uiMeet3dLinksOrdered.length === 0) {
      return null;
    }

    return this.uiMeet3dLinksOrdered[0].endDts;
  }

  render() {
    const {
      t,
      roomId,
      order,
      showConfirmationModalCallback,
      defaultPhotoPathWeb,
      // defaultLogoPathWeb,
      showUiMeet3dLinkFormModalCallback,
    } = this.props;

    return (
      <Segment.Group style={{ marginTop: "1rem" }}>
        <Segment clearing padded>
          {this.organizerUiMeet3dLink.expirationDts < moment() && (
            <Label color="red" attached="top">
              {t("expired")}
            </Label>
          )}
          <div className="ui-meet-3d-link-pair-header">
            <h3>{t("clientPanelMisc:uiMeet3dGeneratedLinkWithIndex", { index: order + 1 })}</h3>
            <div>
              <Button
                primary
                icon
                onClick={() =>
                  showUiMeet3dLinkFormModalCallback(
                    order + 1,
                    roomId,
                    this.organizerUiMeet3dLink.photoPathWeb,
                    this.organizerUiMeet3dLink.logoPathWeb,
                    this.organizerUiMeet3dLink,
                  )
                }
              >
                <Icon name="pencil" />
              </Button>
              <Button icon color="red" onClick={() => showConfirmationModalCallback(order + 1, roomId)}>
                <Icon name="trash" />
              </Button>
            </div>
          </div>
        </Segment>
        <Segment padded>
          <Grid stackable columns={2}>
            <Grid.Row>
              {this.uiMeet3dLinksOrdered.map(uiMeet3dLink => (
                <Grid.Column width={8} key={uiMeet3dLink.uiMeet3dLinkId}>
                  <UiMeet3dLinkCard
                    uiMeet3dLink={uiMeet3dLink}
                    defaultPhotoPathWeb={defaultPhotoPathWeb}
                    // defaultLogoPathWeb={defaultLogoPathWeb}
                  />
                </Grid.Column>
              ))}
            </Grid.Row>
          </Grid>
        </Segment>
        <Segment>
          {this.organizerUiMeet3dLink && (
            <>
              <p>
                <Icon name="calendar" />
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("clientPanelMisc:linkIsValidFromActivationDtsToExpirationDts", {
                      activationDts: this.organizerUiMeet3dLink.activationDts.format("lll"),
                      expirationDts: this.organizerUiMeet3dLink.expirationDts.format("lll"),
                    }),
                  }}
                />
                <br />
                <br />
                <Icon name="calendar alternate" /> {t("creationDate")}:{" "}
                {this.organizerUiMeet3dLink.creationDts.format("lll")}
              </p>
            </>
          )}
        </Segment>
      </Segment.Group>
    );
  }
}

UiMeet3dLinkPairSegment.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.number.isRequired,
  roomId: PropTypes.string.isRequired,
  uiMeet3dLinks: PropTypes.arrayOf(PropTypes.instanceOf(UiMeet3dLink)),
  showConfirmationModalCallback: PropTypes.func.isRequired,
  showUiMeet3dLinkFormModalCallback: PropTypes.func.isRequired,
  defaultPhotoPathWeb: PropTypes.string,
  // defaultLogoPathWeb: PropTypes.string,
};

export default withTranslation()(ErrorWrapper(UiMeet3dLinkPairSegment));
